import React, { useEffect, useState } from 'react';
import { preferencesGroupsStorage } from '../../services/preferencesGroupsStorage';
import { SORTING_DIRECTION_ASC, SORTING_DIRECTION_DESC } from '../../constant';
import { SortIcon } from '../../appearence/icons/sort_icon';
import {IconWrapper} from "../../appearence/icons/icon_wrapper";

const PreferenceGroupsActionsSortIcon = () => {
    const [direction, setDirection] = useState('');
    const changeSortingDirection = () => {
        preferencesGroupsStorage.changeSortingDirection(
            preferencesGroupsStorage.getSortingDirection() === SORTING_DIRECTION_ASC ? 
                SORTING_DIRECTION_DESC 
                : 
                SORTING_DIRECTION_ASC);
    };

    const changeDirectionOfSorting = () => {
        setDirection(preferencesGroupsStorage.getSortingDirection());
    };

    useEffect(() => {
        preferencesGroupsStorage.registerFiltersChangingObserver(changeDirectionOfSorting);
        return () => preferencesGroupsStorage.unRegisterFiltersChangingObserver(changeDirectionOfSorting);
    }, []);

    return (
        <li onClick={changeSortingDirection} key={'phraseSorting'}>
            <IconWrapper>
                <SortIcon/>
            </IconWrapper>
        </li>
    );
};

export default PreferenceGroupsActionsSortIcon;
